import React from 'react';
import { TableColumn, Table, Icon } from '@scale/scaleui';
import Link from '@scale/frontend-lib/link';
import { Routes } from 'react-scale/components/GrowthCenter/urls';
import { transformCSVUrl } from 'react-scale/corp/lib/api/growth';
import { PreviewMetricsModal } from './components/PreviewMetricsModal';

interface SmsTableProps {
  data: object[];
}

type DownloadCSVButtonProps = {
  csvCDSUrl: string;
};

const DownloadCSVButton = ({ csvCDSUrl }: DownloadCSVButtonProps) => {
  return (
    <a
      className="flex items-center"
      target="_blank"
      rel="noopener noreferrer"
      onClick={async e => {
        e.preventDefault();
        const url = await transformCSVUrl(csvCDSUrl);
        window.open(url, '_blank');
      }}
    >
      <Icon icon="download" className="text-xs" size="sm" />
    </a>
  );
};

export const SmsTable: React.FC<SmsTableProps> = ({ data }) => {
  const columns: TableColumn[] = [
    {
      id: 'name',
      header: 'Name',
      enableSorting: true,
      cell: function NameCell(props: any) {
        return (
          <div className="flex flex-col whitespace-normal max-w-[400px]">{props.getValue()}</div>
        );
      },
    },
    {
      id: 'body',
      header: 'SMS Body',
      enableSorting: true,
      cell: function BodyCell(props: any) {
        return (
          <div className="flex flex-col whitespace-normal max-w-[500px]">{props.getValue()}</div>
        );
      },
    },
    {
      id: 'audience',
      header: 'Audience CSV',
      enableSorting: false,
    },
    {
      id: 'metrics',
      header: 'Metrics',
      enableSorting: false,
    },
    {
      id: 'creator',
      header: 'Creator',
      enableSorting: false,
    },
    {
      id: 'createdAt',
      header: 'Created At',
      enableSorting: true,
      cell: function CreatedAtCell(props: any) {
        const createdAt = props.getValue();
        return new Date(createdAt).toLocaleString(undefined, {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      },
    },
  ];

  const processedData = data.map((item: any) => {
    return {
      ...item,
      name: (
        <Link href={`${Routes.SmsSetup}/${item._id}`} as={`/corp${Routes.SmsSetup}/${item._id}`}>
          <a target="_blank" rel="noopener noreferrer">
            <div>{item.name}</div>
          </a>
        </Link>
      ),
      audience: (
        <div className="w-full flex justify-center">
          {item.csvCDSUrl ? (
            <DownloadCSVButton csvCDSUrl={item.csvCDSUrl.toString()} />
          ) : (
            <div>No CSV File</div>
          )}
        </div>
      ),
      creator: item.createdBy
        .split(/[@+]/)[0]
        .replace('.', ' ')
        .replace(/\b\w/g, (l: string) => l.toUpperCase()),
      metrics: (
        <div className="w-full flex justify-center">
          <PreviewMetricsModal communicationId={item._id.toString()} />
        </div>
      ),
    };
  });

  return (
    <div className="w-full">
      <Table columns={columns} data={processedData} />
    </div>
  );
};
